export default __webpack_public_path__ + "static/img4-ebccaa9ecf39f977f366a9992e990541.png";